import * as React from 'react'
import { connect } from 'react-redux'
import {Container, Card, CardImg, CardBody, Row, CardHeader, Col, Button} from "reactstrap";
import {WithTranslation, withTranslation} from "react-i18next";
import {
    ConfiguratorProductAlternativeproducts,
    ProductFamilyIconsInner,
    Product, UsedMainCategoriesInner
} from "App/services/api";
import {extractPrice, SelectedAlternativeProduct} from "App/services";
import {CurrencyProps, Language} from "App/constants";
import {animateScroll} from 'react-scroll';
import {selectSubCategoryPageAction} from "App/routes";
import {selectedLang} from "App/helper";
import {computeDiscount} from "App/basket";

interface StateToProps extends CurrencyProps {
    category: UsedMainCategoriesInner
    subcategory: ProductFamilyIconsInner
    alternativeproducts: Array<ConfiguratorProductAlternativeproducts>
    alternatives: Map<number, SelectedAlternativeProduct>
    standarddiscount: number
    divisionroundtonearest: number | undefined 
}

interface DispatchToProps {
    onShowSubcategory: (catId: number, subId:number) => void
}

const mapDispatchToProps = (dispatch: any) : DispatchToProps => ({
    onShowSubcategory: (catId: number, subId:number) => {
        animateScroll.scrollToTop({smooth:true, duration:800});
        dispatch(selectSubCategoryPageAction(catId, subId));
    },
});

class _Component extends React.PureComponent<StateToProps & DispatchToProps & WithTranslation> {
    render() {
        const {i18n, currency, category, subcategory, alternativeproducts, alternatives,
            t, onShowSubcategory,standarddiscount,divisionroundtonearest} = this.props;
        const language: Language = selectedLang(i18n);
        return <React.Fragment>
            <Card className="mt-6 d-print-none">
                <CardHeader className="px-5 py-3 d-flex align-items-center conf-title">
                    <span className="m-0 w-75 pt-2 float-left title-normal-uppercase">{t('products.configuration.alternativetitle')}</span>
                </CardHeader>
            </Card>
            <Container className="px-0 pt-2 d-print-none">
                <Row className="">
                    {
                        alternativeproducts.map((alternative: ConfiguratorProductAlternativeproducts, index: number) => {
                            const selectedAlternative: SelectedAlternativeProduct | undefined = alternatives.get(alternative.alternativeproductid);
                            const alternativeProduct: Product | null = selectedAlternative?selectedAlternative.product: null;
                            const basePrice: number|null = extractPrice(alternative.price, currency);

                            return <div className="col-sm-6 py-2" key={alternative.alternativeproductid}>
                                <Card className="">
                                    <CardBody className="bodyslice">
                                        <div className="title-small-uppercase">{subcategory.nameml[language]}</div>
                                        <div className="title-large-uppercase">{alternative.nameml[language]}</div>
                                        <CardImg src={alternative.iconurl} alt={alternative.nameml[language]} className="p-0 card-image-small mx-auto d-block"/>
                                        <Row className="pt-2 no-gutters">
                                            <Col className="col-md-6 pb-3">
                                                {alternativeProduct&&alternativeProduct.maincharacteristic1nameml ?
                                                    <React.Fragment>
                                                        <div className="title-small-uppercase">{alternativeProduct.maincharacteristic1nameml[language]}</div>
                                                        <div className="text-bigger-details">{alternativeProduct.maincharacteristic1value}</div>
                                                    </React.Fragment>
                                                    : null
                                                }
                                            </Col>
                                            <Col className="col-md-6 pb-3">
                                                {alternativeProduct&&alternativeProduct.maincharacteristic2nameml ?
                                                    <React.Fragment>
                                                        <div className="title-small-uppercase">{alternativeProduct.maincharacteristic2nameml[language]}</div>
                                                        <div className="text-bigger-details">{alternativeProduct.maincharacteristic2value}</div>
                                                    </React.Fragment>
                                                    : null
                                                }
                                            </Col>
                                            <Col className="col-md-6 pb-3">
                                                {alternativeProduct&&alternativeProduct.maincharacteristic3nameml ?
                                                    <React.Fragment>
                                                        <div className="title-small-uppercase">{alternativeProduct.maincharacteristic3nameml[language]}</div>
                                                        <div className="text-bigger-details">{alternativeProduct.maincharacteristic3value}</div>
                                                    </React.Fragment>
                                                    : null
                                                }
                                            </Col>
                                            <Col className="col-md-6 pb-3">
                                                {alternativeProduct&&alternativeProduct.maincharacteristic3nameml ?
                                                    <React.Fragment>
                                                        <div className="title-small-uppercase">{ t('products.configuration.baseprice') }</div>
                                                        <div className="text-bigger-details">{ t('products.configuration.price', {amount:basePrice?computeDiscount(basePrice, standarddiscount||0, divisionroundtonearest):'-', unit:currency}) }</div>
                                                    </React.Fragment>
                                                    : null
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="align-items-center pb-4 pt-1 no-gutters">
                                            <Col>
                                                <a href={"/configurator/"+category.id+"/categories/"+subcategory.id+"/products/"+alternative.alternativeproductid+"/configuration"}>
                                                <Button className="configure w-100 text-uppercase text-left" >
                                                    <i className="far fa-arrow-circle-right pr-2 fa-lg"></i>{ t('products.configuration.configure') }
                                                </Button>
                                                </a>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </div>}
                        )
                    }
                </Row>
                <Row className="no-gutters mt-2">
                    <Col>
                        <Button className="advice w-100 text-uppercase text-left" onClick={()=>onShowSubcategory(category.id, subcategory.id)}>
                            <i className="far fa-arrow-circle-right pr-2 fa-lg"></i>{ t('products.configuration.showall', {category: subcategory.nameml[language]}) }
                        </Button>
                    </Col>
                </Row>
            </Container>
        </React.Fragment>
    }
}

export const Component = connect(null, mapDispatchToProps)(withTranslation('common')(_Component));


// WEBPACK FOOTER //
// ./src/components/AlternativeProducts.tsx